
/*eslint-disable*/
import React from "react";

// reactstrap components
import { Row, Container } from "reactstrap";

function DemoFooter() {
  return (
    <footer className="footer footer-black footer-white">
      <Container>
        <Row>
          <nav className="footer-nav">
            <ul>
              <li>
                <a
                  href="/about"
                >
                  About Us
                </a>
              </li>
              <li>
                <a
                  href="/contact"
                >
                  Contact Us
                </a>
              </li>
              <li>
                <a
                  href="mailto:ehsanulhaq11199@gmail.com"
                >
                  Developed by Ehsan-ul-haq
                </a>
              </li>
              <li>
              © {new Date().getFullYear()} Janubi Asian Traders
              </li>
            </ul>
          </nav>
          <div className="credits ml-auto">
            <span className="copyright">
             
            </span>
          </div> 
        </Row>
      </Container>
    </footer>
  );
}

export default DemoFooter;
